module.exports = __webpack_public_path__ + "img/villa.9550f254.jpg";